import {defineComponent, toRefs, ref, watch, computed} from "vue";
import { AuditLog } from '@/api/klip-api.proxy';
import { isEmpty } from 'lodash-es';
import DateUtil from '@/app/shared/helpers/date-util';

export default defineComponent({
    name: 'KlAuditLog',
    props: {
        auditLogs: {
            type: Array<AuditLog>,
            default: [],
            required: true
        }
    },
    setup(props) {
        const logs = ref<AuditLog[]>([]);
        const logsChanged = (auditLogs: Array<AuditLog>) => {
            logs.value = auditLogs;
        };

        const formatDate = (timestamp: string) => {
            return DateUtil.formatDateTime(timestamp);
        };

        const hasLogs = computed(() => {
            return !isEmpty(logs.value);
        });

        watch(props.auditLogs, logsChanged, { immediate: true, deep: true });

        return {
            logs,
            hasLogs,
            formatDate
        };
    }
});
